import { createContext, ReactNode, useMemo } from 'react';
import type { TypographyProps } from '../Typography';

type ContextProps = Partial<TypographyProps> & {
    value?: string;
    isRegex?: boolean;
    children?: ReactNode;
};

export const TextHighlighterContext = createContext<ContextProps>({
    value: '',
    isRegex: true,
});

function TextHighlighter({
    children, isRegex = true, ...props
}: ContextProps) {
    const contextValue = useMemo(() => ({
        isRegex,
        ...props,
    }), [isRegex, props]);

    return (
        <TextHighlighterContext.Provider value={contextValue}>
            {children}
        </TextHighlighterContext.Provider>
    );
}

export default TextHighlighter;
